angular.module('userController', [])
.controller('register', function($scope) {
    $scope.user = {};
    $scope.uploadProcessing = false;
    $scope.errors = {};

    $scope.submit = function() {
        $scope.uploadProcessing = true;
        $scope.errors = {};
        var formData = new FormData();
        angular.forEach($scope.user, function(value, key) {
            formData.append(key, value);
        });

        $.ajax({
            method: 'POST',
            url: APP.baseUrl + 'user/store',
            data: formData,
            dataType: 'json',
            contentType: false,
            processData: false,
            responseType: 'json',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
        }).done(function(response) {
            $scope.uploadProcessing = false;
            if (response.status == 'success') {
                $('#popup-container').html(response.popupHtml);
                APP.openColorbox('#popup-container');
            }
        }).fail(function(response, status) {
            $scope.uploadProcessing = false;
            if (status === 422 || response.status == 422) {
                $scope.errors = response.responseJSON || response;
            } else {
                $scope.errors['error'] = ['An error occurred, please try again later'];
            }
            $scope.$apply();
            APP.colorboxResize();
        });
    };
}).controller('login', function($scope) {
    $scope.data = {};
    $scope.uploadProcessing = false;
    $scope.errors = {};

    $scope.submit = function() {
        $scope.uploadProcessing = true;
        $scope.errors = {};
        var formData = new FormData();
        angular.forEach($scope.data, function(value, key) {
            formData.append(key, value);
        });

        $.ajax({
            method: 'POST',
            url: APP.baseUrl + 'user/login',
            data: formData,
            dataType: 'json',
            contentType: false,
            processData: false,
            responseType: 'json',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
        }).done(function(response) {
            $scope.uploadProcessing = false;
            if (response.status == 'success') {
                $scope.data = {};
                $('#popup-container').html(response.popupHtml);
                APP.openColorbox('#popup-container');
            } else {
                $scope.errors['email'] = [response.message];
				APP.colorboxResize();
            }
            $scope.$apply();
        }).fail(function(response, status) {
            $scope.uploadProcessing = false;
            if (status === 422 || response.status == 422) {
                $scope.errors = response.responseJSON || response;
            } else {
                $scope.errors['error'] = ['An error occurred, please try again later'];
            }
            $scope.$apply();
			APP.colorboxResize();
        });
    };
});